import React from 'react';
import { Col, Form, FormGroup, Button, InputGroup } from 'react-bootstrap';
import wrapWithApiData from '../../wrapWithApiData';
import StockSearchDataTable from '../StockSearchDataTable';
import NPPanel from '../../NPPanel';
import LoadingSpinner from '../../LoadingSpinner';


class StockSearchData extends React.Component {
    constructor(props) {
        super(props);

        this.search = this.search.bind(this);
        this.onSelectRow = this.onSelectRow.bind(this);
        this.hideModal = this.hideModal.bind(this);

        this.state = {
            showModal: false,
            selectedRow: null,
        };
    }

    search() {
        this.props.reloadData();
    }

    onSelectRow(row) {
        this.setState({
            showModal: true,
            selectedRow: row,
        });
    }

    hideModal(saved) {
        this.setState({
            showModal: false,
        });

        if(saved) {
            this.props.reloadData();
        }
    }

    render() {
        const { stockSearchData, isLoading, apiToken } = this.props;

        let stockSearchInformationNode = <LoadingSpinner isLoading={true} />;

        if (stockSearchData) {
            stockSearchInformationNode = <StockSearchDataTable data={stockSearchData} isStockSearchData propertyMap={this.propertyMap} apiToken={apiToken} search={this.search} callOffFunctions={this.props.callOffFunctions} />;
        }

        return (
            <NPPanel isLoading={isLoading}>
                <Col sm={12} md={12}>
                     {stockSearchInformationNode}

                     {/* { wrapWithApiData({ dataTillModal: { url: ..., params: ... } }, ModalInnehåll)() } */}
                </Col>
          </NPPanel>) 
    }
}

export default wrapWithApiData({
    apiCalls: { 
        stockSearchData: { url: 'StockSearch/GetStockData' },
    },
}, StockSearchData);